/**
 * Demo Preview i18n — Phase D1.
 *
 * All labels surfaced by the admin Demo Preview UI. Merged into
 * TRANSLATIONS[lang].demoPreview at load time via the existing
 * `_A31_FIX3_APPLY`-style pattern (registered by translations.js).
 */

const T = {
  // Top bar mode switcher.
  modeSwitcher: {
    label: { en: "Mode", es: "Modo", it: "Modalità", fr: "Mode", de: "Modus",
             zh: "模式", "pt-br": "Modo", ja: "モード", hi: "मोड", ko: "모드",
             ru: "Режим", cs: "Režim", nl: "Modus", ar: "الوضع", he: "מצב",
             ca: "Mode",
             eu: "Modua",
             gl: "Modo",
},
    production: { en: "Production", es: "Producción", it: "Produzione", fr: "Production",
                  de: "Produktion", zh: "生产", "pt-br": "Produção", ja: "本番", hi: "उत्पादन",
                  ko: "프로덕션", ru: "Продакшн", cs: "Produkce", nl: "Productie",
                  ar: "إنتاج", he: "ייצור",
                  ca: "Producció",
                  eu: "Ekoizpena",
                  gl: "Produción",
},
    demoPreview: { en: "Demo Preview", es: "Vista Previa Demo", it: "Anteprima Demo",
                   fr: "Aperçu Démo", de: "Demo-Vorschau", zh: "演示预览", "pt-br": "Demo Preview",
                   ja: "デモプレビュー", hi: "डेमो प्रीव्यू", ko: "데모 미리보기",
                   ru: "Демо-режим", cs: "Demo náhled", nl: "Demo-voorbeeld",
                   ar: "معاينة تجريبية", he: "תצוגה מקדימה",
                   ca: "Vista prèvia de demostració",
                   eu: "Demo Aurrebista",
                   gl: "Previsualización de demostración",
},
  },

  // Identity picker dialog.
  picker: {
    title: { en: "Select a demo identity", es: "Selecciona una identidad demo",
             it: "Seleziona un'identità demo", fr: "Sélectionner une identité démo",
             de: "Demo-Identität auswählen", zh: "选择演示身份", "pt-br": "Selecionar identidade demo",
             ja: "デモ ID を選択", hi: "एक डेमो पहचान चुनें", ko: "데모 ID 선택",
             ru: "Выберите демо-идентичность", cs: "Vyberte demo identitu",
             nl: "Selecteer een demo-identiteit", ar: "اختر هوية تجريبية", he: "בחר זהות הדגמה",
             ca: "Selecciona una identitat de demostració",
             eu: "Hautatu demo identitate bat",
             gl: "Selecciona unha identidade de demostración",
},
    subtitle: { en: "You'll preview the app as this profile — no real emails, no production data touched.",
                es: "Verás la app como este perfil — sin emails reales, sin tocar datos de producción.",
                it: "Vedrai l'app come questo profilo — nessuna email reale, nessun dato di produzione modificato.",
                fr: "Vous verrez l'app comme ce profil — aucun email réel, aucune donnée de production affectée.",
                de: "Du siehst die App als dieses Profil — keine echten E-Mails, keine Produktionsdaten betroffen.",
                zh: "你将以此身份预览应用 — 不会发送真实邮件,不会影响生产数据。",
                "pt-br": "Você verá o app como este perfil — sem emails reais, sem afetar dados de produção.",
                ja: "このプロフィールとしてアプリをプレビューします — 実メール送信なし、本番データへの影響なし。",
                hi: "आप इस प्रोफ़ाइल के रूप में ऐप का पूर्वावलोकन करेंगे — कोई वास्तविक ईमेल नहीं, उत्पादन डेटा प्रभावित नहीं।",
                ko: "이 프로필로 앱을 미리 봅니다 — 실제 이메일 발송 없음, 프로덕션 데이터 영향 없음.",
                ru: "Вы увидите приложение от лица этого профиля — без реальных писем и без влияния на продакшн.",
                cs: "Aplikaci si zobrazíte jako tento profil — žádné skutečné e-maily, žádný dopad na produkční data.",
                nl: "Je bekijkt de app als dit profiel — geen echte e-mails, geen invloed op productiedata.",
                ar: "ستعاين التطبيق بهذا الملف — بدون إيميلات حقيقية ودون أي تأثير على بيانات الإنتاج.",
                he: "תצפה באפליקציה כפרופיל זה — ללא מיילים אמיתיים וללא השפעה על נתוני הייצור.",
                ca: "Veuràs l'aplicació amb aquest perfil: cap correu real, cap dada de producció afectada.",
                eu: "Aplikazioa profil honekin aurreikusiko duzu — ez da posta elektroniko errezerik bidaliko, ez da ekoizpen-daturik ukituko.",
                gl: "Previsualizarás a aplicación con este perfil — sen correos reais, sen tocar datos de produción.",
},
    enter: { en: "Enter as this identity", es: "Entrar como esta identidad",
             it: "Entra come questa identità", fr: "Entrer en tant que cette identité",
             de: "Als diese Identität eintreten", zh: "以此身份进入", "pt-br": "Entrar como esta identidade",
             ja: "この ID で開始", hi: "इस पहचान के रूप में दर्ज करें", ko: "이 ID로 시작",
             ru: "Войти как этот профиль", cs: "Vstoupit jako tato identita",
             nl: "Inloggen als deze identiteit", ar: "ادخل بهذه الهوية", he: "כניסה כזהות זו",
             ca: "Entra amb aquesta identitat",
             eu: "Sartu identitate honekin",
             gl: "Entrar con esta identidade",
},
    empty: { en: "No demo identities available.", es: "No hay identidades demo disponibles.",
             it: "Nessuna identità demo disponibile.", fr: "Aucune identité démo disponible.",
             de: "Keine Demo-Identitäten verfügbar.", zh: "暂无演示身份。", "pt-br": "Nenhuma identidade demo disponível.",
             ja: "利用可能なデモ ID はありません。", hi: "कोई डेमो पहचान उपलब्ध नहीं।",
             ko: "사용 가능한 데모 ID 없음.", ru: "Демо-идентичностей нет.",
             cs: "Žádné demo identity.", nl: "Geen demo-identiteiten beschikbaar.",
             ar: "لا توجد هويات تجريبية متاحة.", he: "אין זהויות הדגמה זמינות.",
             ca: "No hi ha identitats de demostració disponibles.",
             eu: "Ez dago demo identitaterik eskuragarri.",
             gl: "Non hai identidades de demostración dispoñibles.",
},
  },

  // Floating chip + exit.
  chip: {
    badge: { en: "DEMO PREVIEW", es: "VISTA PREVIA DEMO", it: "ANTEPRIMA DEMO",
             fr: "APERÇU DÉMO", de: "DEMO-VORSCHAU", zh: "演示预览", "pt-br": "DEMO PREVIEW",
             ja: "デモプレビュー", hi: "डेमो प्रीव्यू", ko: "데모 미리보기",
             ru: "ДЕМО-РЕЖИМ", cs: "DEMO NÁHLED", nl: "DEMO-VOORBEELD",
             ar: "معاينة تجريبية", he: "תצוגה מקדימה",
             ca: "VISTA PRÈVIA DE DEMOSTRACIÓ",
             eu: "DEMO AURREBISTA",
             gl: "PREVISUALIZACIÓN DE DEMOSTRACIÓN",
},
    exit: { en: "Exit demo", es: "Salir del demo", it: "Esci dalla demo",
            fr: "Quitter la démo", de: "Demo verlassen", zh: "退出演示", "pt-br": "Sair do demo",
            ja: "デモを終了", hi: "डेमो से बाहर निकलें", ko: "데모 종료",
            ru: "Выйти из демо", cs: "Ukončit demo", nl: "Demo verlaten",
            ar: "الخروج من العرض", he: "צא מההדגמה",
            ca: "Surt de la demostració",
            eu: "Irten demotik",
            gl: "Saír da demostración",
},
    expiresIn: { en: "expires in", es: "caduca en", it: "scade in", fr: "expire dans",
                 de: "läuft ab in", zh: "剩余", "pt-br": "expira em", ja: "残り",
                 hi: "समाप्ति", ko: "만료까지", ru: "истекает через", cs: "vyprší za",
                 nl: "verloopt over", ar: "ينتهي خلال", he: "פג בעוד",
                 ca: "caduca en",
                 eu: "iraungitzea:",
                 gl: "caduca en",
},
  },

  // Role labels (mirror DemoIdentity.profile_type).
  roles: {
    player: { en: "Player", es: "Jugador/a", it: "Giocatore", fr: "Joueur",
              de: "Spieler", zh: "球员", "pt-br": "Jogador", ja: "選手", hi: "खिलाड़ी",
              ko: "선수", ru: "Игрок", cs: "Hráč", nl: "Speler", ar: "لاعب", he: "שחקן",
              ca: "Jugador",
              eu: "Jokalaria",
              gl: "Xogador",
},
    parent_guardian: { en: "Parent / Guardian", es: "Padre / Tutor", it: "Genitore / Tutore",
                      fr: "Parent / Tuteur", de: "Eltern / Erziehungsberechtigte/r",
                      zh: "家长 / 监护人", "pt-br": "Pai / Responsável", ja: "保護者",
                      hi: "अभिभावक", ko: "보호자", ru: "Родитель / опекун",
                      cs: "Rodič / opatrovník", nl: "Ouder / voogd",
                      ar: "ولي الأمر", he: "הורה / אפוטרופוס",
                      ca: "Pare / Tutor",
                      eu: "Guraso / Tutore",
                      gl: "Nai/Pai / Titor",
},
    coach: { en: "Coach", es: "Entrenador/a", it: "Allenatore", fr: "Entraîneur",
             de: "Trainer", zh: "教练", "pt-br": "Treinador", ja: "コーチ",
             hi: "कोच", ko: "코치", ru: "Тренер", cs: "Trenér", nl: "Coach",
             ar: "مدرّب", he: "מאמן",
             ca: "Entrenador",
             eu: "Entrenatzailea",
             gl: "Adestrador",
},
    head_coach: { en: "Head Coach", es: "Entrenador Principal", it: "Capo Allenatore",
                  fr: "Entraîneur Principal", de: "Cheftrainer", zh: "主教练",
                  "pt-br": "Treinador Principal", ja: "ヘッドコーチ",
                  hi: "हेड कोच", ko: "헤드 코치", ru: "Главный тренер",
                  cs: "Hlavní trenér", nl: "Hoofdcoach",
                  ar: "المدرب الرئيسي", he: "מאמן ראשי",
                  ca: "Entrenador principal",
                  eu: "Entrenatzaile Nagusia",
                  gl: "Adestrador Principal",
},
    club_manager: { en: "Club / Academy", es: "Club / Academia", it: "Club / Accademia",
                    fr: "Club / Académie", de: "Club / Akademie", zh: "俱乐部 / 学院",
                    "pt-br": "Clube / Academia", ja: "クラブ / アカデミー",
                    hi: "क्लब / अकादमी", ko: "클럽 / 아카데미", ru: "Клуб / академия",
                    cs: "Klub / akademie", nl: "Club / Academie",
                    ar: "نادي / أكاديمية", he: "מועדון / אקדמיה",
                    ca: "Club / Acadèmia",
                    eu: "Kluba / Akademia",
                    gl: "Club / Academia",
},
    federation_manager: { en: "Federation / Institution", es: "Federación / Institución",
                          it: "Federazione / Istituzione", fr: "Fédération / Institution",
                          de: "Verband / Institution", zh: "联合会 / 机构",
                          "pt-br": "Federação / Instituição",
                          ja: "連盟 / 機関",
                          hi: "महासंघ / संस्थान", ko: "연맹 / 기관",
                          ru: "Федерация / учреждение", cs: "Federace / instituce",
                          nl: "Federatie / instelling",
                          ar: "اتحاد / مؤسسة", he: "התאחדות / מוסד",
                          ca: "Federació / Institució",
                          eu: "Federazioa / Erakundea",
                          gl: "Federación / Institución",
},
    stringer: { en: "Stringer / Racket Technician", es: "Encordador / Técnico de Raqueta",
                it: "Incordatore / Tecnico Racchette", fr: "Cordeur / Technicien Raquette",
                de: "Besaiter / Schläger-Techniker", zh: "穿线师 / 球拍技师",
                "pt-br": "Cordoeiro / Técnico de Raquete",
                ja: "ストリンガー / ラケット技術者",
                hi: "स्ट्रिंगर / रैकेट तकनीशियन",
                ko: "스트링거 / 라켓 기술자",
                ru: "Стрингер / техник по ракеткам",
                cs: "Vyplétač / racketový technik",
                nl: "Bespanner / racket-technicus",
                ar: "ستينجر / فني المضارب", he: "סטרינגר / טכנאי מחבטים",
                ca: "Encordador / Tècnic de raquetes",
                eu: "Soke-teknikaria / Raketa-teknikaria",
                gl: "Encordador / Técnico de Raquetas",
},
    sponsor: { en: "Sponsor", es: "Patrocinador", it: "Sponsor", fr: "Sponsor",
               de: "Sponsor", zh: "赞助商", "pt-br": "Patrocinador", ja: "スポンサー",
               hi: "प्रायोजक", ko: "스폰서", ru: "Спонсор", cs: "Sponzor",
               nl: "Sponsor", ar: "راعٍ", he: "ספונסר",
               ca: "Patrocinador",
               eu: "Babeslea",
               gl: "Patrocinador",
},
    medical: { en: "Medical / Physio / Fitness", es: "Médico / Fisio / Fitness",
               it: "Medico / Fisio / Fitness", fr: "Médical / Kiné / Fitness",
               de: "Medizin / Physio / Fitness", zh: "医疗 / 理疗 / 健身",
               "pt-br": "Médico / Fisio / Fitness",
               ja: "メディカル / フィジオ / フィットネス",
               hi: "मेडिकल / फिजियो / फिटनेस",
               ko: "메디컬 / 물리치료 / 피트니스",
               ru: "Медицина / физио / фитнес",
               cs: "Lékař / fyzio / fitness",
               nl: "Medisch / fysio / fitness",
               ar: "طبي / علاج طبيعي / لياقة",
               he: "רפואי / פיזיו / כושר",
               ca: "Mèdic / Fisio / Preparador físic",
               eu: "Medikua / Fisioterapeuta / Prestakuntza Fisikoa",
               gl: "Médico / Fisio / Preparación Física",
},
  },

  // Generic errors emitted by the backend.
  errors: {
    demo_readonly_mode: {
      en: "Read-only mode. Phase D1 doesn't allow writes — they'll come in Phase D3 with sandbox isolation.",
      es: "Modo solo lectura. La fase D1 no permite escrituras — llegarán en la fase D3 con aislamiento sandbox.",
      it: "Modalità sola lettura. La fase D1 non consente scritture — arriveranno nella fase D3 con sandbox.",
      fr: "Mode lecture seule. La phase D1 n'autorise pas les écritures — elles arriveront en phase D3 avec sandbox.",
      de: "Nur-Lese-Modus. Phase D1 erlaubt keine Schreibvorgänge — sie kommen in Phase D3 mit Sandbox.",
      zh: "只读模式。D1 阶段不允许写入 —— 将在 D3 阶段通过沙箱隔离引入。",
      "pt-br": "Modo somente leitura. A fase D1 não permite gravações — virão na fase D3 com sandbox.",
      ja: "読み取り専用モードです。フェーズ D1 では書き込みは許可されていません — フェーズ D3 でサンドボックスとともに導入されます。",
      hi: "केवल पढ़ने का मोड। चरण D1 लिखने की अनुमति नहीं देता — वे चरण D3 में सैंडबॉक्स के साथ आएँगे।",
      ko: "읽기 전용 모드입니다. D1 단계에서는 쓰기를 허용하지 않으며 D3 단계의 샌드박스에서 도입됩니다.",
      ru: "Режим только для чтения. На этапе D1 запись запрещена — она появится на этапе D3 в песочнице.",
      cs: "Pouze pro čtení. Fáze D1 zápisy nepovoluje — přijdou v D3 v sandboxu.",
      nl: "Alleen-lezen-modus. Fase D1 staat geen schrijfbewerkingen toe — die komen in fase D3 met sandbox.",
      ar: "وضع للقراءة فقط. لا تسمح المرحلة D1 بالكتابة — ستصل في المرحلة D3 مع العزل في صندوق رمل.",
      he: "מצב קריאה בלבד. שלב D1 לא מאפשר כתיבות — הן יגיעו בשלב D3 עם בידוד sandbox.",
      ca: "Mode només lectura. La fase D1 no permet escriptura: arribarà a la fase D3 amb aïllament sandbox.",
      eu: "Irakurketa soileko modua. D1 faseak ez du idazketarik onartzen — D3 fasean etorriko dira, sandbox isolamenduarekin.",
      gl: "Modo só lectura. A fase D1 non permite escrituras — chegarán na fase D3 con illamento de sandbox.",
    },
    demo_path_blocked: {
      en: "This action is blocked in Demo Preview to protect production data (exports, broadcasts, etc.).",
      es: "Esta acción está bloqueada en Vista Previa Demo para proteger los datos de producción (exportaciones, envíos, etc.).",
      it: "Questa azione è bloccata in Anteprima Demo per proteggere i dati di produzione (esportazioni, invii, ecc.).",
      fr: "Cette action est bloquée en Aperçu Démo pour protéger les données de production (exports, envois, etc.).",
      de: "Diese Aktion ist in der Demo-Vorschau blockiert, um Produktionsdaten zu schützen (Exporte, Versand usw.).",
      zh: "为保护生产数据,演示预览中已阻止此操作(导出、群发等)。",
      "pt-br": "Esta ação está bloqueada no Demo Preview para proteger dados de produção (exportações, envios, etc.).",
      ja: "本番データ保護のため、デモプレビューではこの操作はブロックされています(エクスポート、配信など)。",
      hi: "उत्पादन डेटा की सुरक्षा हेतु डेमो प्रीव्यू में यह क्रिया अवरुद्ध है (निर्यात, प्रसारण आदि)।",
      ko: "프로덕션 데이터 보호를 위해 데모 미리보기에서 이 작업이 차단됩니다(내보내기, 브로드캐스트 등).",
      ru: "Это действие заблокировано в демо-режиме для защиты продакшн-данных (экспорт, рассылка и т. п.).",
      cs: "Tato akce je v demo náhledu zablokována pro ochranu produkčních dat (exporty, rozesílky atd.).",
      nl: "Deze actie is geblokkeerd in Demo-voorbeeld om productiedata te beschermen (exports, verzendingen, enz.).",
      ar: "تم حظر هذا الإجراء في معاينة العرض لحماية بيانات الإنتاج (التصدير، البث، إلخ).",
      he: "פעולה זו חסומה בתצוגה המקדימה כדי להגן על נתוני הייצור (יצוא, שידור וכו').",
      ca: "Aquesta acció està bloquejada a la Vista prèvia de demostració per protegir les dades de producció (exportacions, difusions, etc.).",
      eu: "Ekintza hau blokeatuta dago Demo Aurrebistan ekoizpen-datuak babesteko (esportazioak, hedapenak, etab.).",
      gl: "Esta acción está bloqueada na Previsualización de demostración para protexer os datos de produción (exportacións, difusións, etc.).",
    },
    demo_session_expired: {
      en: "Demo session expired. Please start a new one.",
      es: "La sesión demo ha caducado. Inicia una nueva.",
      it: "Sessione demo scaduta. Avviane una nuova.",
      fr: "Session démo expirée. Démarrez-en une nouvelle.",
      de: "Demo-Sitzung abgelaufen. Bitte neue starten.",
      zh: "演示会话已过期。请开始新会话。",
      "pt-br": "Sessão demo expirada. Inicie uma nova.",
      ja: "デモセッションが期限切れです。新しいセッションを開始してください。",
      hi: "डेमो सत्र समाप्त। कृपया नया प्रारंभ करें।",
      ko: "데모 세션이 만료되었습니다. 새 세션을 시작하세요.",
      ru: "Демо-сессия истекла. Начните новую.",
      cs: "Demo relace vypršela. Spusťte novou.",
      nl: "Demosessie verlopen. Start een nieuwe.",
      ar: "انتهت جلسة العرض. ابدأ جلسة جديدة.",
      he: "פג תוקף של סשן ההדגמה. התחל חדש.",
      ca: "Sessió de demostració caducada. Inicia'n una de nova.",
      eu: "Demo saioa iraungi da. Hasi berri bat, mesedez.",
      gl: "A sesión de demostración caducou. Por favor, inicia unha nova.",
    },
    demo_session_revoked: {
      en: "Demo session ended.", es: "Sesión demo finalizada.",
      it: "Sessione demo terminata.", fr: "Session démo terminée.",
      de: "Demo-Sitzung beendet.", zh: "演示会话已结束。",
      "pt-br": "Sessão demo encerrada.", ja: "デモセッションを終了しました。",
      hi: "डेमो सत्र समाप्त।", ko: "데모 세션이 종료되었습니다.",
      ru: "Демо-сессия завершена.", cs: "Demo relace ukončena.",
      nl: "Demosessie beëindigd.", ar: "تم إنهاء جلسة العرض.",
      he: "סשן ההדגמה הסתיים.",
      ca: "Sessió de demostració finalitzada.",
      eu: "Demo saioa amaitu da.",
      gl: "A sesión de demostración rematou.",
    },
  },

  // D3-Phase-B — tiny inline pill rendered next to any object the
  // backend tagged with `_demo_state`. EN/ES authored; other langs
  // fall back to EN via the merge loop below.
  badge: {
    created: {
      en: "Demo · new", es: "Demo · nuevo",
      it: "Demo · nuovo", fr: "Démo · nouveau",
      de: "Demo · neu", "pt-br": "Demo · novo",
      ca: "Demo · nou",
      eu: "Demo · berria",
      gl: "Demostración · novo",
      ar: "عرض توضيحي · جديد",
      he: "הדגמה · חדש",
      zh: "Demo · 新建",
      ja: "デモ · 新規",
      hi: "Demo · नया",
      ko: "데모 · 신규",
      ru: "Demo · новая",
      cs: "Demo · nové",
      nl: "Demo · nieuw",
    },
    modified: {
      en: "Demo · edited", es: "Demo · editado",
      it: "Demo · modificato", fr: "Démo · modifié",
      de: "Demo · bearbeitet", "pt-br": "Demo · editado",
      ca: "Demo · editat",
      eu: "Demo · editatua",
      gl: "Demostración · editado",
      ar: "عرض توضيحي · تم التعديل",
      he: "הדגמה · נערך",
      zh: "Demo · 已编辑",
      ja: "デモ · 編集済み",
      hi: "Demo · संपादित",
      ko: "데모 · 수정됨",
      ru: "Demo · отредактирована",
      cs: "Demo · upraveno",
      nl: "Demo · bewerkt",
    },
  },
};

/**
 * Merge the demoPreview namespace + errors into the global TRANSLATIONS
 * dict. Called from `translations.js` at import time.
 */
export function applyDemoPreviewI18n(TRANSLATIONS) {
  const LANGS = Object.keys(TRANSLATIONS);
  for (const lang of LANGS) {
    const node = (TRANSLATIONS[lang].demoPreview = TRANSLATIONS[lang].demoPreview || {});
    node.modeSwitcher = {
      label: (T.modeSwitcher.label[lang] || T.modeSwitcher.label.en),
      production: (T.modeSwitcher.production[lang] || T.modeSwitcher.production.en),
      demoPreview: (T.modeSwitcher.demoPreview[lang] || T.modeSwitcher.demoPreview.en),
    };
    node.picker = {
      title: (T.picker.title[lang] || T.picker.title.en),
      subtitle: (T.picker.subtitle[lang] || T.picker.subtitle.en),
      enter: (T.picker.enter[lang] || T.picker.enter.en),
      empty: (T.picker.empty[lang] || T.picker.empty.en),
    };
    node.chip = {
      badge: (T.chip.badge[lang] || T.chip.badge.en),
      exit: (T.chip.exit[lang] || T.chip.exit.en),
      expiresIn: (T.chip.expiresIn[lang] || T.chip.expiresIn.en),
    };
    node.roles = {};
    for (const role of Object.keys(T.roles)) {
      node.roles[role] = (T.roles[role][lang] || T.roles[role].en);
    }
    // D3-Phase-B — top-level `demoBadge.*` namespace so the
    // <DemoWriteBadge /> component can call t("demoBadge.created")
    // from anywhere in the app without depending on the demoPreview
    // admin tree.
    const badge = (TRANSLATIONS[lang].demoBadge = TRANSLATIONS[lang].demoBadge || {});
    badge.created = (T.badge.created[lang] || T.badge.created.en);
    badge.modified = (T.badge.modified[lang] || T.badge.modified.en);
    // Merge errors into the global errors block.
    const errs = (TRANSLATIONS[lang].errors = TRANSLATIONS[lang].errors || {});
    for (const code of Object.keys(T.errors)) {
      errs[code] = (T.errors[code][lang] || T.errors[code].en);
    }
  }
}
